<p-toast></p-toast>
<div class="mw-100">
<app-navbar></app-navbar>
<div class="row ">
    <div class="container">
        <app-account-details></app-account-details>
    </div>
    <div class="container">
        <app-changpassword ></app-changpassword>
    </div>
    <!-- <div class="container">
        <app-notification></app-notification>
    </div>
    <div class="container">
        <app-payments-card></app-payments-card>
    </div> -->
</div>
</div>